import { TimeTrackingProjectGuard } from './time-tracking-project-guard.guard';
import { TimeTrackingRedirectionGuard } from './time-tracking-redirection.guard';

const Guards = [TimeTrackingRedirectionGuard, TimeTrackingProjectGuard];

export { TimeTrackingRedirectionGuard, TimeTrackingProjectGuard, Guards };
